import Immutable from 'immutable';
import * as types from '../../actions/candidate/candidate-document-types/types';
import reducerCreator from '../../tools/reducer-creator';

const initialState = Immutable.fromJS({
  types: [],
  isLoading: false
});

export default reducerCreator(initialState, {
  [types.CANDIDATE_DOCUMENT_TYPES_SET_LOADING]: (state, { isLoading }) =>
    state.set('isLoading', isLoading),

  [types.CANDIDATE_DOCUMENT_TYPES_SET_TYPES]: (state, { documentTypes }) =>
    state.set('types', Immutable.fromJS(documentTypes)),

  [types.CANDIDATE_DOCUMENT_TYPES_RESET_TYPES]: () => initialState
});



// WEBPACK FOOTER //
// ./src/reducers/candidate/candidate-document-types.js